// src/pages/PrivacyPolicyPage.js
import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="container my-5">
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> April 6, 2025</p>

      <p>
        At RxRooster, your privacy matters. This Privacy Policy explains how we collect, use, and protect the personal
        information you share with us. By using our website or services, you agree to the practices described below.
      </p>

      <h5>1. Information We Collect</h5>
      <p>We may collect the following types of information:</p>
      <ul>
        <li><strong>Contact Information:</strong> Name, email address, phone number</li>
        <li><strong>Professional Details:</strong> Employment history, certifications, availability, compensation expectations</li>
        <li><strong>Facility Information:</strong> Coverage needs, location, contact person’s details</li>
        <li><strong>Technical Information:</strong> Browser type, device information, IP address (for analytics)</li>
      </ul>

      <h5>2. How We Use Your Information</h5>
      <p>We use your information to:</p>
      <ul>
        <li>Match CRNAs with appropriate healthcare facilities</li>
        <li>Schedule and conduct consultations</li>
        <li>Communicate with you about opportunities or services</li>
        <li>Improve our platform, services, and user experience</li>
      </ul>

      <h5>3. Information Sharing</h5>
      <p>
        We do not sell your personal data. We only share relevant information with:
      </p>
      <ul>
        <li>Healthcare facilities or CRNAs during the matching process (with your consent)</li>
        <li>Trusted service providers who help us operate our platform (e.g., email, analytics)</li>
        <li>Law enforcement or legal authorities, if required by law</li>
      </ul>

      <h5>4. Data Security</h5>
      <p>
        We take data protection seriously and use reasonable technical and organizational measures to safeguard your
        information. However, no method of transmission over the internet is 100% secure.
      </p>

      <h5>5. Your Choices</h5>
      <p>You may:</p>
      <ul>
        <li>Request access to or correction of your data</li>
        <li>Withdraw consent at any time</li>
        <li>Request deletion of your personal data from our systems</li>
      </ul>

      <h5>6. Children’s Privacy</h5>
      <p>
        RxRooster is not intended for use by children under the age of 18. We do not knowingly collect personal
        information from children.
      </p>

      <h5>7. Changes to This Policy</h5>
      <p>
        We may update this Privacy Policy from time to time. If we make changes, we’ll post the updated policy here with the
        new effective date.
      </p>

      <h5>8. Contact Us</h5>
      <p>
        If you have any questions about this Privacy Policy, please email us at <a href="mailto:support@rxrooster.com">support@rxrooster.com</a>.
      </p>

      <p className="mt-4">Thank you for trusting RxRooster.</p>
    </div>
  );
};

export default PrivacyPolicyPage;
